//@flow
import React from "react";
import "./wishlist-right-aside.scss";

export function WishlistRightAside() {
  return (
    <div className="wishlist-main__aside">
      <div className="wishlist-info-block wishlist-main__info-block book-a-consultation-container">
        <div className="wishlist-info-block__heading">
          <i className="icon-reece icon-reece-max-Book_Appointment-stroke wishlist-info-block__heading-icon" />
          <span className="wishlist-info-block__heading-text">
            BOOK A CONSULTATION
          </span>
        </div>
        <p>
          Book a consultation with a showroom consultant - either via audio,
          video call or in-store with responsible social distancing - to turn
          your wishlist into an official Reece Quote and receive expert advice.
        </p>
        <a
          href="/bathrooms/book-a-consultation"
          className="wishlist-info-block__cta"
        >
          BOOK NOW
        </a>
      </div>
    </div>
  );
}
